import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message, Table } from "antd";
import { FiPlus } from "react-icons/fi";
import { BsThreeDots } from "react-icons/bs";
import { Popover } from "antd";
import { CiCircleAlert } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import Instance from "../../AxiosConfig";
import { Form, Button } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const IndividualTraineeTable = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [certificationData, setCertificationData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerCertPage = 10;
  const token = localStorage.getItem("token");

  // Fetch all certifications
  const fetchCertificationData = async (page = 1) => {
    setLoading(true);
    try {
      const response = await Instance.get("/individualCertification/", {
        params: { page, limit: itemsPerCertPage },
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Certification Data:", response.data);
      if (response.status === 200 || response.status === 201) {
        setCertificationData(response.data.certifications || []);
      }
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

  // Fetch filtered data
  const handleFilter = async () => {
    setLoading(true);
    try {
      const params = {
        search: search.trim() || "",
        status: status === "All" ? "" : status,
        fromDate: fromDate || "",
        toDate: toDate || "",
        page: currentPage,
        limit: itemsPerCertPage,
      };

      const response = await Instance.get("/certification/filter", {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 || response.status === 201) {
        setCertificationData(response.data.certifications || []);
      } else {
        setCertificationData([]);
        message.warning("No certifications found for the given filters");
      }
    } catch (error) {
      console.error(error.response);
      message.error("Failed to fetch filtered data");
    } finally {
      setLoading(false);
    }
  };

  // Clear filters
  const handleClearFilters = () => {
    setSearch("");
    setStatus("All");
    setFromDate(null);
    setToDate(null);
    fetchCertificationData(1);
  };

  useEffect(() => {
    fetchCertificationData();
  }, []);

  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [selectedAction, setSelectedAction] = useState({});
  const [selectedData, setSelectedData] = useState(null);

  const handleAddCertificate = () => {
    navigate("/add-new-individual-certification");
  };

  const handleDeleteConfirm = async () => {
    if (!recordToDelete) return;

    const token = localStorage.getItem("token");
    try {
      await Instance.delete(`/individualCertification/delete/${recordToDelete._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Update state to remove deleted item
      setCertificationData((prevData) =>
        prevData.filter((item) => item._id !== recordToDelete._id)
      );

      message.success("Certification deleted successfully");
      setShowDeleteConfirm(false);
      setRecordToDelete(null);
      setShowDeleteToast(true);

      // Auto-hide toast
      setTimeout(() => {
        setShowDeleteToast(false);
      }, 3000);
    } catch (error) {
      console.error(error.response);
      message.error(error.response?.data?.message || "Failed to delete certification");
    }
  };
  const columns = [
    {
      title: "Company Name",
      dataIndex: "companyName",
            render: (_, record) => record.companyName || "-",

    },
    {
      title: "Agent Name",
      dataIndex:"agentName",
      render: (_, record) => record.assignedAgent?.agentName || "-",
    },
    // {
    //   title: "Scope of Work",
    //   dataIndex: "scopeofwork",
    //   key: "scopeofwork",
    // },
    {
      title: "Standard",
      dataIndex: "standard",
    },
    {
      title: "Certificate Number",
      dataIndex: "certificationNumber",
    },
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "City",
      dataIndex: "city",
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Registration",
      dataIndex: "dateOfRegistration",
      render: (date) =>
        date ? new Date(date).toISOString().split("T")[0] : "-",
    },
    // {
    //   title: "1st Audit",
    //   dataIndex: "firstSurveillanceAudit",
    //   render: (date) =>
    //     date ? new Date(date).toISOString().split("T")[0] : "-",
    // },
    // {
    //   title: "2nd Audit",
    //   dataIndex: "secondSurveillanceAudit",
    //   render: (date) =>
    //     date ? new Date(date).toISOString().split("T")[0] : "-",
    // },
    {
      title: "Expiry Date",
      dataIndex: "certificationExpiryDate",
      render: (date) =>
        date ? new Date(date).toISOString().split("T")[0] : "-",
    },
    // {
    //   title: "Number",
    //   dataIndex: "number",
    // },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const lowerStatus = status.toLowerCase();
        let bgColor = "";
        let textColor = "";

        if (lowerStatus === "active") {
          bgColor = "#DFF6E4";
          textColor = "#0CBC53";
        } else if (lowerStatus === "inactive") {
          bgColor = "#FFF4E5";
          textColor = "#FFA500";
        } else {
          bgColor = "#F6D7FE";
          textColor = "#D138F8";
        }

        const statusTag = (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "12px",
              fontWeight: 500,
              display: "inline-block",
              minWidth: "70px",
              textAlign: "center",
              cursor: lowerStatus === "not work" ? "pointer" : "default",
            }}
          >
            {status}
          </span>
        );

        if (lowerStatus === "not work") {
          return (
            <Popover
              content="Certification documents are under review by audit team"
              placement="top"
              overlayInnerStyle={{
                transform: "translateX(-40px)",
                borderRadius: "15px",
              }}
            >
              {statusTag}
            </Popover>
          );
        }

        return statusTag;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => {
        const rowKey = record._id;
        const isOpen = selectedAction[rowKey]?.open;
        const selectedBtn = selectedAction[rowKey]?.type;

        const handleToggleActions = (e) => {
          e.stopPropagation();
          setSelectedAction((prev) => {
            if (prev[rowKey]?.open) {
              return { ...prev, [rowKey]: { open: false, type: null } };
            }
            return { [rowKey]: { open: true, type: null } };
          });
        };

        const handleActionClick = (type) => {
          setSelectedAction((prev) => ({
            ...prev,
            [rowKey]: { open: true, type },
          }));

          if (type === "view") {
            navigate(`/view-individual-certification/${record._id}`, {
              state: { record },
            });
          } else if (type === "edit") {
            navigate(`/edit-individual-certification/${record._id}`, {
              state: { record },
            });
          } else if (type === "delete") {
            setRecordToDelete(record);
            setShowDeleteConfirm(true);
          } 
        };

        return (
          <div style={{ position: "relative" }}>
            <BsThreeDots
              style={{ fontSize: "20px", cursor: "pointer" }}
              onClick={handleToggleActions}
            />
            {isOpen && (
              <div className="action-button-group">
                {["view", "edit", "delete"].map((action) => (
                  <button
                    key={action}
                    className={`inline-action-btn ${
                      selectedBtn === action ? "selected" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation(); // prevent row click override
                      handleActionClick(action);
                    }}
                  >
                    {action.charAt(0).toUpperCase() + action.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className="filter-card p-3">
        <Form>
          <div className="row g-3">
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>Search</Form.Label>
                <Form.Control
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search..."
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option>All</option>
                  <option>Active</option>
                  <option>Inactive</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>From</Form.Label>
                <DatePicker
                  className="form-control"
                  value={fromDate ? dayjs(fromDate) : null}
                  onChange={(date) =>
                    setFromDate(date ? date.format("YYYY-MM-DD") : null)
                  }
                  format="YYYY-MM-DD"
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>To</Form.Label>
                <DatePicker
                  className="form-control"
                  value={toDate ? dayjs(toDate) : null}
                  onChange={(date) =>
                    setToDate(date ? date.format("YYYY-MM-DD") : null)
                  }
                  format="YYYY-MM-DD"
                />
              </Form.Group>
            </div>
          </div>
        </Form>

        <div className="d-flex justify-content-end gap-4 my-3">
          <button className="clear-btn-company" onClick={handleClearFilters}>
            CLEAR FILTERS
          </button>
          <button className="clear-btn-company" onClick={handleFilter}>
            Submit
          </button>
        </div>
      </div>

      {showDeleteToast && (
        <div className="download-toast">
          <span>Company deleted successfully</span>
          <button
            className="toast-close-btn"
            onClick={() => setShowDeleteToast(false)}
          >
            <RxCross2 size={18} />
          </button>
        </div>
      )}
      {showDeleteConfirm && (
        <div
          className="delete-modal-overlay"
          onClick={() => setShowDeleteConfirm(false)}
        >
          <div
            className="delete-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="alert-content">
              <CiCircleAlert className="alert-icon" />
              <h2>Are you sure?</h2>
              <p>
                Do you really want to delete this file? This action cannot be
                undone.
              </p>
            </div>
            <div className="d-flex justify-content-around align-items-center gap-3 mt-4">
              <button
                className="cancel-btn"
                onClick={() => setShowDeleteConfirm(false)}
              >
                Cancel
              </button>
              <button className="delete-btn" onClick={handleDeleteConfirm}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="certification-page mt-5">
        <div className="certificate-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1>Individual Trainee Certifications List</h1>
            <button
              className="add-certification-btn"
              onClick={handleAddCertificate}
            >
              <FiPlus /> Add New Certification
            </button>
          </div>
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={certificationData}
              loading={loading}
              style={{ cursor: "pointer" }}
              pagination={{
                pageSize: itemsPerCertPage,
                current: currentPage,
                onChange: (page) => {
                  setCurrentPage(page);
                },
                className: "custom-pagination",
              }}
              scroll={{ x: "max-content" }}
              // onRow={(record) => {
              //   return {
              //     onClick: () => {
              //       navigate(`/edit-individual-certification/${record._id}`, {
              //         state: { id: record._id },
              //       });
              //     },
              //   };
              // }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualTraineeTable;
